export const PlannerSelectors = {
    DECORATOR_FULL_ID : '#planer',
    DECORATOR_ID : 'planer',
    MODAL: {
        MODAL_ID: "#planner-modal",
        MODAL_CONTENT_ID: '#planner-modal-content',
        AGREE: {
            CHECKBOX: '#planner_agree',
            BUTTONS: '.planner-agree-button'
        },
        SAVE_FOR_UNLOGGED: {
            FORM: '.planner-save-form',
            EMAIL: '.planner-save-email',
            SUBMIT: '.planner-save-submit'
        },
        ASSIGN_PROJECT: {
            FORM: '.planner-assign-form',
            NUMBER: '.planner-assign-number',
            SUBMIT: '.planner-assign-submit'
        },
        FIND_PROJECTS: {
            FORM: '.planner-find-projects-form',
            PHRASE: '#planner-find-projects-phrase',
            SUBMIT: '.planner-find-projects-submit'
        },
        USER_PROJECTS_LIST:{
            PAGE_BUTTONS: '#planner-modal .page-link',
            LOAD_PROJECT_BTN: '.planner-load-project',
            DELETE_PROJECT_BTN: '.planner-delete-project',
        },
        FORCE_ADD_TO_CART: '.planner-force-add-to-cart',
        BACK_TO_PROJECTS_BTN: '.planner-back-to-projects',
        CONFIRM_DELETE_PROJECT_BTN: '.planner-confirm-delete'
    },
    CART_ICON: {
        CART_COUNT: ".js_cart_count",
        OFFER_COUNT: '.js_offer_count'
    },
    SPINNER: '#planner-small-spinner',
    MAIN_HEADER:'.main-header',
    TOOGLER : '#login-panel--toggler, #login-panel--toggler-desktop',
    ACCOUNT_BTN : '#btn-account',
    LOGIN_FORM : '#loginForm',
    LOGIN_PANEL : '#login-panel',
    SIGN_OUT : '#sign-out'
}export const PlannerSelectors = {
    DECORATOR_FULL_ID : '#planer',
    DECORATOR_ID : 'planer',
    MODAL: {
        MODAL_ID: "#planner-modal",
        MODAL_CONTENT_ID: '#planner-modal-content',
        AGREE: {
            CHECKBOX: '#planner_agree',
            BUTTONS: '.planner-agree-button'
        },
        SAVE_FOR_UNLOGGED: {
            FORM: '.planner-save-form',
            EMAIL: '.planner-save-email',
            SUBMIT: '.planner-save-submit'
        },
        ASSIGN_PROJECT: {
            FORM: '.planner-assign-form',
            NUMBER: '.planner-assign-number',
            SUBMIT: '.planner-assign-submit'
        },
        FIND_PROJECTS: {
            FORM: '.planner-find-projects-form',
            PHRASE: '#planner-find-projects-phrase',
            SUBMIT: '.planner-find-projects-submit'
        },
        USER_PROJECTS_LIST:{
            PAGE_BUTTONS: '#planner-modal .page-link',
            LOAD_PROJECT_BTN: '.planner-load-project',
            DELETE_PROJECT_BTN: '.planner-delete-project',
        },
        FORCE_ADD_TO_CART: '.planner-force-add-to-cart',
        BACK_TO_PROJECTS_BTN: '.planner-back-to-projects',
        CONFIRM_DELETE_PROJECT_BTN: '.planner-confirm-delete'
    },
    CART_ICON: {
        CART_COUNT: ".js_cart_count",
        OFFER_COUNT: '.js_offer_count'
    },
    SPINNER: '#planner-small-spinner',
    MAIN_HEADER:'.main-header',
    TOOGLER : '#login-panel--toggler, #login-panel--toggler-desktop',
    ACCOUNT_BTN : '#btn-account',
    LOGIN_FORM : '#loginForm',
    LOGIN_PANEL : '#login-panel',
    SIGN_OUT : '#sign-out'
}